import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "auth"
}

import { computed, PropType } from 'vue';
import LogoImg from '~components/LogoImg.vue';
import AppLoader from '~components/AppLoader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthLayout',
  props: {
  authInProcess: {
    type: Boolean as PropType<boolean>,
  },
},
  emits: ['openLoginPopup'],
  setup(__props, { emit }) {

const notAutorizedText = computed(() => 'Вы не авторизованы в системе'.toUpperCase());




return (_ctx: any,_cache: any) => {
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_banner = _resolveComponent("q-banner")!

  return (__props.authInProcess)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_q_inner_loading, {
          showing: true,
          label: "Идет авторизация..."
        }, {
          default: _withCtx(() => [
            _createVNode(AppLoader)
          ]),
          _: 1
        })
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _createVNode(_component_q_banner, { class: "bg-grey-3 auth-banner" }, {
          avatar: _withCtx(() => [
            _createVNode(LogoImg)
          ]),
          action: _withCtx(() => [
            _createVNode(_component_q_btn, {
              flat: "",
              color: "accent",
              label: "Вход",
              onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emit('openLoginPopup')), ["prevent"])),
              onKeypress: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('openLoginPopup')), ["enter"]))
            })
          ]),
          default: _withCtx(() => [
            _createTextVNode(" " + _toDisplayString(_unref(notAutorizedText)) + " ", 1)
          ]),
          _: 1
        })
      ]))
}
}

})